import { Button, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import { Receipt } from '@mui/icons-material';

const ActionButton = ({ row, setBaixa, resetStates, handleChangeLocations, getBaixaDataById }) => {
    const handleOpen = async () => {
        setBaixa({
            id: row.id,
            itemId: row.item_id,
            almoxarifado: row.almoxarifado_id,
            localizacao: row.localizacao_id,
            unidade: row.unidade_id,
            observacao: row.observacao,
            quantidade: row.quantidade,
            data: row.data
        });
        handleChangeLocations(row.almoxarifado_id);
        resetStates();
    };

    return (
        <Box>
            <Tooltip title="Editar Baixa">
                <Button onClick={handleOpen}>
                    <EditIcon />
                </Button>
            </Tooltip>
            <Tooltip title="Relatório">
                <Button onClick={() => getBaixaDataById(row.id)}>
                    <Receipt />
                </Button>
            </Tooltip>
        </Box>
    );
};

export default ActionButton;
